import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ArrowLeft } from "lucide-react";

import { PreferencesTab } from "./PreferencesTab";
import { ProfileTab } from "./ProfileTab";
import { PROFILE_NAV_ITEMS, type ProfileTabKey } from "./types";

interface ProfilePageViewProps {
  activeTab: ProfileTabKey;
  onTabChange: (tab: ProfileTabKey) => void;
  onBack: () => void;
}

export const ProfilePageView = ({ activeTab, onTabChange, onBack }: ProfilePageViewProps) => {
  return (
    <div className="mx-auto w-full max-w-5xl px-4 py-10 sm:px-6">
      <button
        type="button"
        onClick={onBack}
        className="mb-4 inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-sm font-medium text-muted-foreground transition-colors hover:bg-surface-sunken hover:text-foreground focus-visible:shadow-focus focus-visible:outline-none"
      >
        <ArrowLeft size={16} />
        Back
      </button>
      <h1 className="mb-6 text-2xl font-bold tracking-tight text-foreground">Account Settings</h1>
      <Tabs
        value={activeTab}
        onValueChange={(value) => onTabChange(value as ProfileTabKey)}
        orientation="vertical"
        className="flex flex-col gap-8 md:grid md:grid-cols-[15rem_minmax(0,1fr)] md:items-start md:gap-10"
      >
        <aside className="w-full shrink-0 md:border-r md:border-border md:pr-6">
          <p className="hidden px-3 pb-2 text-xs font-semibold uppercase tracking-wide text-muted-foreground md:block">
            Settings
          </p>
          <TabsList className="flex h-auto w-full flex-row items-stretch justify-start gap-1 overflow-x-auto rounded-none bg-transparent p-0 md:flex-col md:overflow-visible">
            {PROFILE_NAV_ITEMS.map(({ key, label, icon: Icon }) => (
              <TabsTrigger
                key={key}
                value={key}
                className="flex shrink-0 items-center justify-start gap-2 rounded-xl px-3 py-2.5 text-sm font-semibold text-muted-foreground shadow-none transition-colors hover:bg-surface-subtle hover:text-foreground data-[state=active]:bg-primary-subtle data-[state=active]:text-primary-emphasis data-[state=active]:shadow-none"
              >
                <Icon size={18} />
                {label}
              </TabsTrigger>
            ))}
          </TabsList>
        </aside>

        <div className="min-w-0 flex-1">
          <TabsContent value="profile" className="mt-0 max-w-2xl">
            <h2 className="mb-4 text-lg font-bold text-foreground">Profile</h2>
            <ProfileTab />
          </TabsContent>
          <TabsContent value="preferences" className="mt-0 max-w-2xl">
            <h2 className="mb-4 text-lg font-bold text-foreground">Export Defaults</h2>
            <PreferencesTab />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
};
